<template>
  <div class="applyService">
    <div class="prompt">
      <div class="title">温馨提示:</div>
      <div class="word">
        本服务仅适用于户籍地和居住地在本街道、60岁以上且身体健康的老人，有高血压、心脏病等疾病的老人请勿申请。
      </div>
    </div>
    <div class="container">
      <div class="info_form">
        <van-form ref="form">
          <div class="contain">
            <yellow-mark></yellow-mark>
            主要信息
            <van-field name="name" readonly label="姓名" :value="fullName" />
            <van-field name="picker" readonly label="性别" :value="sex" />
          </div>

          <div class="contain">
            <yellow-mark></yellow-mark>
            其他信息
            <van-field name="手机号" readonly label="手机号" :value="mobile" />
            <van-field
              name="身份证号"
              readonly
              label="身份证号"
              :value="idCard"
            />
            <van-field name="年龄" readonly label="年龄" :value="age" />
            <van-field
              name="所属居委"
              readonly
              label="所属居委"
              :value="committee"
            />
          </div>

          <div class="contain" v-if="personInfo.fullName">
            <yellow-mark></yellow-mark>
            代理人
            <van-field
              name="代理人姓名"
              label="代理人姓名"
              readonly
              v-model="userInfo.fullName"
            />
            <van-field
              name="手机号"
              readonly
              label="手机号"
              v-model="userInfo.mobile"
            />
          </div>
          <div class="contain">
            <yellow-mark></yellow-mark>
            备注
            <van-field
              v-model="remark"
              autosize
              type="textarea"
              placeholder="请填写备注，字数不超过200字"
            />
          </div>

          <van-button
            :loading="loading"
            class="bot done_bot"
            style="margin: 16px;"
            @click="onSubmit"
          >
            提交
          </van-button>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { addApplyService } from "@/api/service.js";
import { getUserInfoDetail, getDistrictSelect } from "@/api/user.js";
import { GetAge } from "@/utils/dataDeelMethod.js";
import { mapState } from "vuex";
export default {
  name: "ApplyService",
  data() {
    return {
      remark: "",
      userInfo: {},
      personInfo: this.$route.query,
      loading: false,
      committeeData: []
    };
  },
  methods: {
    async onSubmit() {
      console.log("remark", this.remark);
      let form = {
        remark: this.remark,

        serviceProjectId: this.serviceId
      };
      if (this.personInfo.fullName) {
        form = Object.assign(this.personInfo, form);
      } else {
        form = Object.assign(this.userInfo, form);
      }
      console.log("form", form);
      delete form.params;
      this.loading = true;
      console.log(form);
      const { code } = await addApplyService(form);
      this.loading = false;
      if (code !== 0) {
        this.$toast({
          message: "申请服务失败",
          icon: require("@/assets/images/success.png")
        });
      } else {
        this.$toast({
          message: "申请服务成功",
          icon: require("@/assets/images/success.png")
        });
        this.$router.replace("applicationRecord");
      }
    }
  },
  async mounted() {
    window.document.title = "申请" + this.serviceName;
    const { data } = await getUserInfoDetail(this.$store.state.user.openId);
    this.userInfo = data;
    console.log("userInfo", this.userInfo);
    const { data: result } = await getDistrictSelect({
      screenConfigType: "通用",
      screenName: "南京东路街道大屏"
    });
    this.committeeData = result;
  },
  computed: {
    ...mapState("service", ["serviceId", "serviceName"]),
    fullName() {
      return this.personInfo.fullName
        ? this.personInfo.fullName
        : this.userInfo.fullName;
    },
    sex() {
      if (this.personInfo.sex) {
        return this.personInfo.sex === "1" ? "女" : "男";
      } else {
        return this.userInfo.sex === "1" ? "女" : "男";
      }
    },
    mobile() {
      return this.personInfo.mobile
        ? this.personInfo.mobile
        : this.userInfo.mobile;
    },
    idCard() {
      return this.personInfo.idCard
        ? this.personInfo.idCard
        : this.userInfo.idCard;
    },
    age() {
      return this.personInfo.idCard
        ? GetAge(this.personInfo.idCard)
        : GetAge(this.userInfo.idCard);
    },
    committee() {
      let str = this.personInfo.areaCode || this.userInfo.areaCode;
      let committee = "";
      this.committeeData.forEach(item => {
        if (item.screenConfigValue === str) {
          committee = item.screenConfigKey;
        }
      });
      return committee;
    }
  }
};
</script>

<style lang="scss" scoped>
.applyService {
  padding-bottom: 50px;
  .prompt {
    padding: 0 30px;
    margin-bottom: 10px;
    .title {
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #ff0000;
      line-height: 24px;
    }
    .word {
      opacity: 1;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: left;
      color: #757a8c;
      line-height: 24px;
    }
  }
  .container {
    .info_form {
      .van-form {
        .contain {
          border-bottom: 8px solid #fff8e9;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #543302;
          line-height: 40px;

          .yellowMark {
            vertical-align: baseline;
            margin-right: 10px;
          }
        }

        .van-field {
          padding-left: 36px;
          ::v-deep {
            .van-cell__title {
              span {
                position: relative;
                width: 46px;
                height: 22px;
                opacity: 1;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                text-align: left;
                color: #543302;
              }
            }
          }
        }
      }
      .van-popup {
        .title {
          margin: 0 auto;
          width: 304px;
          height: 61px;
          opacity: 1;
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #000000;
          line-height: 61px;
          border-bottom: 1px solid #707070;
        }
      }
      .bot {
        position: fixed;
        bottom: 0;
        z-index: 999;
        width: 100%;
        margin: 0 !important;
        width: 375px;
        height: 49px;
        opacity: 1;
        background: #ffedbb;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        color: #543302;
        line-height: 49px;
        font-size: 18px;
      }
      .done_bot {
        background-color: #ffd63c;
      }
      .bottom {
        position: absolute;
        bottom: 0;
        z-index: 999;
        width: 100%;
        margin: 0 !important;
        width: 375px;
        height: 49px;
        opacity: 1;
        background: #ffd63c;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        color: #543302;
        line-height: 49px;
        font-size: 18px;
      }
    }
  }
}
</style>
